import { isTestMode } from "./isTestMode";

// /ba-image/:id is the SERVER redirect shim: it looks up the photo and 302s to
// the real S3/CloudFront URL (private → a fresh short-lived SIGNED url, which is
// why the shim still matters for private — a baked-in signed url would expire).
// For PUBLIC photos, prefer the DIRECT CloudFront url (s3ImageUrl/s3ThumbUrl from
// GraphQL) straight in the <img> so the box is out of the path entirely; only
// use this helper when you have an id but no url (or for private re-signing).
//
// Returns undefined (NOT "") when there is no id so React omits the src attr.
// `variant: 'thumb'` requests the thumbnail derivative (for grids/lists).
export const baImageUrl = (photoId, { variant } = {}) => {
  if (!photoId) return undefined;
  const params = [];
  if (variant) params.push(`variant=${variant}`);
  if (isTestMode()) params.push("db=test");
  return `/ba-image/${photoId}${params.length ? `?${params.join("&")}` : ""}`;
};
